import { render, staticRenderFns } from "./BuildingSocietyEscalationFile.vue?vue&type=template&id=6ffef593&scoped=true&"
import script from "./BuildingSocietyEscalationFile.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyEscalationFile.vue?vue&type=style&index=0&id=6ffef593&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffef593",
  null
  
)

export default component.exports